import {
    FaShoppingCart,
    FaCloud,
    FaHospital,
    FaChartLine,
    FaRocket,
    FaBuilding,
    FaBook,
    FaHotel
} from "react-icons/fa";

export default function Section8() {
    const industries = [
        {
            title: "Ecommerce & Retail",
            text: " Boost product discoverability, optimize category pages, and turn search traffic into revenue with data-driven ecommerce SEO strategies.",
            icon: <FaShoppingCart className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
        },
        {
            title: "SaaS & Technology",
            text: " Reach decision-makers and generate high-quality leads with SEO campaigns designed for complex products and competitive tech markets.",
            icon: <FaCloud className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
        },
        {
            title: "Healthcare & Medical",
            text: "Enhance local visibility and build credibility so patients can easily find and trust your services when they need them most",
            icon: <FaHospital className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
        },
        {
            title: "Finance & FinTech",
            text: "Strengthen your online authority and attract the right audience through strategic, trust-focused SEO approaches",
            icon: <FaChartLine className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
        },
        {
            title: "Startups &  Small Businesses",
            text: "Maximize your growth potential with targeted SEO strategies that help you compete effectively even against larger, established brands.",
            icon: <FaRocket className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
        },
        {
            title: "Agencies & Enterprises",
            text: " Scale your digital presence with advanced SEO solutions built for multi-location businesses and enterprise-level operations.",
            icon: <FaBuilding className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
        },
        {
            title: "Education & E-Learning",
            text: "Increase visibility for your programs, attract the right learners, and drive more enrollments through optimized content and search strategies",
            icon: <FaBook className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
        },
        {
            title: "Hospitality & Travel",
            text: " Capture high-intent search traffic and convert it into bookings with SEO strategies tailored for travel and hospitality businesses.",
            icon: <FaHotel className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
        }
    ];

    return (
        <div className="Section8 py-[60px] md:py-[100px] bg-[#f9f9f9]">
            <div className="text-center mb-16 max-w-4xl mx-auto">
                <h2 className="text-[28px] md:text-[36px] font-bold text-[#151515] leading-[32px] md:leading-[41px]">
                    SEO Solutions for Every Industry in Texas
                </h2>
                <p className="mt-6 text-[#555] text-[16px] md:text-[18px] max-w-[600px] mx-auto">
                    Our SEO services are tailored to meet the unique demands of different industries, helping businesses across Texas improve visibility, attract qualified traffic, and drive consistent growth.
                </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-12 md:gap-16 w-[90%] md:w-[85%] mx-auto">
                {industries.map((industry, index) => (
                    <div
                        key={index}
                        className="flex flex-col items-center text-center transition transform hover:-translate-y-2 hover:scale-105 duration-300"
                    >
                        {/* Icon */}
                        <div className="mb-4">{industry.icon}</div>

                        {/* Title */}
                        <h3 className="text-[18px] md:text-[20px] font-semibold text-[#151515] mb-2">
                            {industry.title}
                        </h3>

                        {/* Description */}
                        <p className="text-gray-600 text-sm md:text-base">{industry.text}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
